// extracted by mini-css-extract-plugin
export default {"gallery":"ModalGallery_gallery__UP-Ge","arrowContainer":"ModalGallery_arrowContainer__SCZmI","arrowInnerContainer":"ModalGallery_arrowInnerContainer__k2wce"};